<!-- @format -->

<!-- There can be several types of badges. We only are interested to show those two ones -->
<ng-container *ngIf="badgeType === 'verifiedPurchaser'">
	<ng-container
		*ngTemplateOutlet="
			badge;
			context: {
				icon: 'sign-circled-check-outline',
				text: 'Verified Purchase',
				verified: true
			}
		"></ng-container>
</ng-container>

<ng-container *ngIf="badgeType === 'incentivizedReview'">
	<ng-container
		*ngTemplateOutlet="
			badge;
			context: { icon: 'money-giftcard', text: 'Received incentive', verified: false }
		"></ng-container>
</ng-container>

<ng-template
	#badge
	let-icon="icon"
	let-text="text"
	let-verified="verified">
	<div class="review-badges hmf-display-flex hmf-justify-content-start hmf-align-items-center">
		<homefield-icon
			class="info-badge-verified hmf-mr-xxxs hmf-display-flex hmf-justify-content-center hmf-align-items-center"
			[width]="verified ? '16px' : '12px'"
			[height]="verified ? '16px' : '12px'"
			[name]="icon"
			[fill]="verified ? 'var(--hmf-label-positive)' : ''">
		</homefield-icon>
		<div class="review-badges-type" [ngClass]="verified ? 'label-positive hmf-body-bold-s' : 'label-secondary-static hmf-body-s'">
			{{ text }}
		</div>
	</div>
</ng-template>